module.exports = __webpack_public_path__ + "img/nrg.2b8b3700.png";